import { render, staticRenderFns } from "./CriteriaLibrary.vue?vue&type=template&id=573b3aaa&scoped=true"
import script from "./CriteriaLibrary.vue?vue&type=script&lang=ts"
export * from "./CriteriaLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b3aaa",
  null
  
)

export default component.exports